module.exports = __webpack_public_path__ + "img/SmartInterface_mehrfarbig_RGB.c21efec6.svg";